import { render, staticRenderFns } from "./question-input.vue?vue&type=template&id=7c4aa537&scoped=true"
import script from "./question-input.vue?vue&type=script&lang=js"
export * from "./question-input.vue?vue&type=script&lang=js"
import style0 from "./question-input.vue?vue&type=style&index=0&id=7c4aa537&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4aa537",
  null
  
)

export default component.exports